// Translations
import landing from '../views/landing/translations/ar'

// Translation: Password change (Arabic)
export default Object.freeze({
	name: '',
	views: { landing }
})
